(ns machtfit.stepchall.nav-bar
  (:require [machtfit.app.routes :as routes]
            [machtfit.startpage.subs :as startpage.subs]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [t]]
            [re-frame.core :as rf]))

(defn- item [{:keys [icon title subpage link-attrs]}]
  (let [page {:id :stepchall
              :subpage subpage}]
    [:li [:a (merge (routes/attrs-link-to-page (or link-attrs page))
                    {:class (when (and (nil? link-attrs)
                                       (= subpage @(rf/subscribe [:get [:ui :page :subpage]]))) "active")})
          [:i.sc_icon icon] [:span title]]]))

(defn nav-bar []
  (when (or @(rf/subscribe [::subs/is-team-member?])
            @(rf/subscribe [::subs/is-spectator?]))
    [:div.sc_nav-bar
     [:nav
      (when (and @(rf/subscribe [:get [:is-app?]])
                 @(rf/subscribe [::startpage.subs/app-version-3?]))
        [item {:title (t {:de "Home"
                          :en "Home"})
               :icon [icons/home]
               :link-attrs {:id :home}}])
      [item {:title (t {:de "Route"
                        :en "Route"})
             :icon [icons/route]
             :subpage nil}]
      [item {:title (t {:de "Bestenliste"
                        :en "Leaderboard"})
             :icon [icons/leaderboard]
             :subpage :leaderboard}]
      (when @(rf/subscribe [::subs/is-team-member?])
        [:<>
         [item {:title "Team"
                :icon [icons/my-team]
                :subpage :my-team}]
         [item {:title (t {:de "Aktivität"
                           :en "Activity"})
                :icon [icons/my-steps]
                :subpage :my-steps}]])]]))
